@use "Styles/includes/variables";
@use "Styles/mixins";

$itemHorizontalPadding: 16px;

// styles for all items
:host {
    display: flex;
    align-items: center;
    column-gap: 8px;
    padding: 8px $itemHorizontalPadding;
    transition: background-color 0.15s ease;

    .vm-dropdown-item {
        &__label-wrap {
            display: flex;
            align-items: center;
            gap: 8px;
        }

        &__label {
            width: 100%;
            margin: 0;
            font-family: variables.$fontQuaternary;
            font-size: 14px;
            line-height: 20px;
            font-weight: var(--dropdown-item-font-weight, 700);
            color: mixins.get-color(text, text-secondary);
        }
    }
}

::slotted([slot="icon-leading"]),
::slotted([slot="icon-trailing"]) {
    width: 16px;
    height: 16px;
}

:host(:not([group])) {
    cursor: pointer;
}

// hover styles for items with no "group" prop
:host(:not([group]):hover) {
    background-color: var(--dropdown-item-hover-background, mixins.get-color(background, bg-brand-secondary));
}

// styles for items with "group" prop
:host([group]) {
    flex-direction: column;
    align-items: stretch;
    padding: 0;

    .vm-dropdown-item {
        &__label-wrap {
            padding: 8px 16px 0;
        }
    }
}

// styles for item with "groupitem" prop
:host([groupitem]) {
    flex-direction: row;
    padding: 11px 10px 11px 34px;
}

:host([groupitem]) {
    .vm-dropdown-item {
        &__label {
            font-weight: var(--dropdown-item-font-weight, 400);
        }
    }
}

// styles for the divider between items
// start with item 2
:host(:nth-of-type(n + 2)) {
    position: relative;

    &::before {
        content: " ";
        position: absolute;
        top: -1px;
        left: 0;
        right: 0;
        height: 1px;
        background-color: mixins.get-color(border, border-secondary);
    }
}

// styles for the divider between items with "groupitem" prop
// start with item 2
:host([groupitem]:nth-of-type(n + 2)) {
    &::before {
        left: var(--dropdown-item-divider-position-left, calc($itemHorizontalPadding + 10px));
        right: var(--dropdown-item-divider-position-right, 0);
    }
}
